
import { min } from 'lodash';

export const buildChartConfig = ( windowInnerWidth = window.innerWidth ) => {
    let svgMaxWidth = 1185;
    let paddingFromWidgetEnd = 12;
    let svgScreenShare = .62;
    let svgWidth = min( [( windowInnerWidth * svgScreenShare ) - paddingFromWidgetEnd, svgMaxWidth] );
    let aspectRatio = .77;
    let svgHeight = svgWidth * aspectRatio;

    return {
        chartRightBorder: svgWidth - 50,
        chartRightBorderOffset: 0,
        height: svgHeight,
        width: svgWidth,
        xAxisHeight: 22,
        xAxisTickEnd: svgWidth - 150,
        xAxisTickStart: 30,
    };
};
